import { useCallback } from 'react';
import { useMyInfo } from 'shared/src/queries';
import { usePostRedeemCoupon } from '../queries/usePostRedeemCoupon';
import { bridge } from 'shared/src/utils';
import type { Coupon } from 'shared/src/api/marketCouponService/getMarketCouponList';
import { useLogCompleteDownloadCoupon } from './useLogCompleteDownloadCoupon';

export const useOnPressRedeemCoupon = (marketId: number) => {
  const { data: myInfo } = useMyInfo();
  const { mutateAsync: postRedeemCoupon } = usePostRedeemCoupon(marketId);
  const logCompleteRedeemCoupon = useLogCompleteDownloadCoupon(marketId);

  return {
    action: useCallback<(coupon: Coupon) => Promise<void>>(
      async coupon => {
        if (!myInfo) return;
        if (myInfo.is_anonymous) {
          bridge.assertLogin({});
          bridge.toast('로그인이나 회원가입이 필요해요');
          return;
        }

        await postRedeemCoupon({ sno: coupon.sno });
        logCompleteRedeemCoupon({ coupon, isDownloadAll: false });
      },
      [logCompleteRedeemCoupon, myInfo, postRedeemCoupon],
    ),
    loading: false,
  };
};
